
import React from 'react';

const ApplicantItem = ({ applicant, isSelected, onSelect, jobTitle }) => {
  return (
    <div 
      className={`applicant-item ${isSelected ? 'selected' : ''}`}
      onClick={onSelect}
      style={{ padding: '15px 20px' }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div>
          <div style={{ fontSize: '1.2rem', fontWeight: 600, color: '#2d3748', marginBottom: '4px' }}>
            {applicant.name}
          </div>
          <div style={{ fontSize: '0.9rem', color: '#667eea', fontWeight: 500 }}>
            {jobTitle || 'No role provided'}
          </div>
        </div>
        <div style={{
          background: 'linear-gradient(45deg, #667eea, #764ba2)',
          color: 'white',
          padding: '8px 15px',
          borderRadius: '20px',
          fontWeight: 600,
          fontSize: '1rem',
          flexShrink: 0,
          marginLeft: '15px'
        }}>
          {applicant.overall.toFixed(1)}/10
        </div>
      </div>
    </div>
  );
};

export default ApplicantItem;
